export default {
  eyebrow: 'Kumppaniportaali',
  title: 'Brändäys',
  description: 'White label -portaalisi ja kirjautumissivusi ulkoasu.',
  page: {
    read_only_notice: 'Vain luku. Muuta arvoja napsauttamalla Muokkaa.',
    editing_notice: 'Muokataan — muutokset näkyvät tiimillesi ja asiakkaillesi.',
  },
  branding: {
    scope_hint:
      'Koskee white label -portaaliasi ja kirjautumissivuasi — ei ravintoloidesi Storefronteja, jotka brändätään ravintolakohtaisesti.',
    upload: 'Lataa logo',
    logo: {
      label: 'Logo',
      hint: 'Näkyy white label -pinnoillasi.',
    },
    circle_logo: {
      label: 'Favicon / pyöreä logo',
      hint: 'Neliömäinen logo, jota käytetään faviconina ja avatarina. Valinnainen — voidaan poistaa.',
    },
    splash_image: {
      label: 'Kirjautumiskuva',
      hint: 'Näkyy white label -kirjautumissivullasi. Suositus: vähintään 1200 px leveä. Valinnainen — voidaan poistaa.',
    },
    footer_note: 'Lisää brändäysvaihtoehtoja (toissijaiset värit) tulossa myöhemmin.',
  },
  form: {
    primary_color: {
      label: 'Ensisijainen brändiväri',
      hint: 'Teemoittaa kumppaniportaalisi ja kirjautumisen.',
    },
    dashboard_subdomain: {
      label: 'Kumppanin kirjautumistunnus',
      hint: 'Pienaakkosin kirjoitettu tunnus — tunnistaa brändisi tiimin kirjautumislinkissä (?partner=…).',
      placeholder: 'kumppanin-nimi',
    },
    login_url: {
      label: 'Tiimin kirjautumislinkki',
      hint: 'Jaa tämä linkki tiimillesi — se avaa kirjautumissivun brändilläsi.',
    },
    file: {
      label: 'Kuva',
    },
  },
  login_url_warning: {
    title: 'Vaihdetaanko tiimin kirjautumislinkki?',
    description:
      'Tiimisi kirjautumislinkki vaihtuu osoitteeseen {{url}}. Jaa jatkossa uusi linkki — vanha ei enää näytä brändiäsi.',
    description_no_url: 'Tiimisi kirjautumislinkki vaihtuu. Jaa jatkossa uusi linkki — vanha ei enää näytä brändiäsi.',
  },
  login_url_changed: {
    title: 'Tiimin kirjautumislinkki vaihdettu',
    description: 'Tiimisi kirjautuu nyt osoitteessa {{url}}. Tallenna uusi linkki kirjanmerkiksi ja jaa se tiimillesi.',
  },
  buttons: {
    edit: 'Muokkaa',
    cancel: 'Peruuta',
    save: 'Tallenna',
  },
  toasts: {
    load_error: 'Brändäystietoja ei voitu ladata.',
    failed_to_save_changes: 'Muutosten tallennus epäonnistui',
    changes_got_saved: 'Muutokset tallennettu',
    logo_uploaded: 'Logo ladattu',
    logo_upload_failed: 'Logon lataaminen epäonnistui',
    logo_removed: 'Logo poistettu',
    logo_remove_failed: 'Logon poistaminen epäonnistui',
    file_too_large: 'Tiedosto on liian suuri. Enimmäiskoko on {{max}} Mt.',
    image_too_narrow: 'Kirjautumiskuvan on oltava vähintään {{min}} px leveä.',
  },
};
